<template>
  <div class="execution">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        :key="tableKey"
        v-model="form"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="handleDel"
        @sort-change="sortChange"
      >
        <template slot="menu" slot-scope="{ row }">
          <el-button
            type="text"
            v-if="permissions['chain:excavatorModelManage:edit']"
            size="small"
            plain
            @click="edit(row)"
          >
            编辑</el-button
          >
          <el-button
            type="text"
            v-if="permissions['chain:excavatorModelManage:del']"
            size="small"
            plain
            @click="del(row)"
          >
            删除</el-button
          >
        </template>
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <el-button
              v-if="permissions['chain:excavatorModelManage:upload']"
              size="small"
              style="margin-right: 20px"
              @click="uploadVisible = true"
              >导入</el-button
            >
            <span class="reset" @click="reset"> 重置筛选条件 </span>
          </div>
        </template>
        <template slot="menuLeft" slot-scope="{ row, index }">
          <!-- <el-button
            type="primary"
            v-if="permissions['chain:excavatorModelManage:upload']"
            size="small"
            icon="el-icon-upload2"
            @click="uploadVisible=true"
            >导入</el-button
          > -->
          <el-button
            type="primary"
            v-if="permissions['chain:excavatorModelManage:upload']"
            size="small"
            @click="add"
            >新增</el-button
          >
        </template>
      </avue-crud>

      <!-- 删除 -->
      <el-dialog
        width="548px"
        :close-on-click-modal="false"
        :visible.sync="delVisible"
      >
        <template slot="title">
          <div class="check-title">
            <i
              class="el-icon-info"
              style="color: #35b1ff; margin-right: 8px"
            ></i>
            确定要删除本挖机型号吗？
          </div>
        </template>
        <div class="desc">
          删除后，该挖机型号将不能被选择进行签单工作，请谨慎操作。
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="delVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleDel">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 新增 -->
      <el-dialog
        :title="`${addForm.id ? '编辑' : '新增'}挖机型号`"
        width="640px"
        :close-on-click-modal="false"
        custom-class="pc-dialog"
        :visible.sync="addVisible"
      >
        <el-form :model="addForm" :rules="addRules" ref="addForm">
          <el-form-item prop="ownerName" label="挖机车主:">
            <el-input
              v-model="addForm.ownerName"
              placeholder="请输入挖机车主"
            ></el-input>
          </el-form-item>
          <el-form-item prop="ownerMobile" label="车主手机:">
            <el-input
              v-model="addForm.ownerMobile"
              placeholder="请输入车主手机"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item prop="machineCode" label="挖机型号:">
            <el-input
              v-model="addForm.machineCode"
              placeholder="请输入挖机型号"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave('addForm')"
            >保存</el-button
          >
        </div>
      </el-dialog>
    </basic-container>
    <uploadImport
      ref="uploadImport"
      v-if="uploadVisible"
      :visible.sync="uploadVisible"
      @imtExcel="imtExcel"
      :templateUrl="templateUrl"
    ></uploadImport>
  </div>
</template>

<script>
import {
  getPage,
  addObj,
  putObj,
  delObj,
  importExcel,
} from "@/api/chain/excavatorModelManage";
import { tableOption } from "@/const/crud/chain/excavatorModelManage";
import { mapGetters } from "vuex";
import uploadImport from "@/components/uploadImport";
import { isMobileNumber } from "@/util/validate";
export default {
  name: "excavatorModelManage",
  components: {
    uploadImport,
  },
  data() {
    return {
      tableKey:0,
      delVisible: false,
      addVisible: false,
      addForm: {
        ownerName: "",
        ownerMobile: "",
        machineCode: "",
      },
      addRules: {
        ownerName: [
          { required: true, message: "请输入挖机车主", trigger: "blur" },
        ],
        ownerMobile: [
          { required: true, message: "请输入车主手机", trigger: "blur" },
          {
            validator: isMobileNumber,
            trigger: "blur",
          },
        ],
        machineCode: [
          { required: true, message: "请输入挖机型号", trigger: "blur" },
        ],
      },
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption,
      uploadVisible: false,
      templateUrl:
        "https://jyb-app.obs.cn-south-1.myhuaweicloud.com:443/1%2Fappdownload%2Fa34d5867-6d4b-482d-b2d4-d93243ab070f.xls?attname=挖机型号管理.xls",
    };
  },
  created() {},
  mounted: function () {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:excavatorModelManage:add"]
          ? true
          : false,
        delBtn: this.permissions["chain:excavatorModelManage:del"]
          ? true
          : false,
        editBtn: this.permissions["chain:excavatorModelManage:edit"]
          ? true
          : false,
        viewBtn: this.permissions["chain:excavatorModelManage:get"]
          ? true
          : false,
      };
    },
  },
  methods: {
    updateTableHeight() {
        this.tableOption.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        this.tableKey += 1
    },
    edit(row) {
      this.addForm = row;
      this.addVisible = true;
    },
    del(row) {
      this.addForm = row;
      this.delVisible = true;
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    add() {
      this.addForm = {};
      this.addVisible = true;
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      delObj(this.addForm.id).then((data) => {
        _this.$message({
          showClose: true,
          message: "删除成功",
          type: "success",
        });
        this.delVisible=false
        this.getPage(this.page);
      });
      // this.$confirm("是否确认删除此数据", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(function () {
      //     return
      //   })

      //   .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.id) {
            putObj(this.addForm)
              .then((response) => {
                this.$message({
                  showClose: true,
                  message: "修改成功",
                  type: "success",
                });
                this.addForm = {};
                this.addVisible = false;
                // done();
                this.getPage(this.page);
              })
              .catch(() => {
                loading();
              });
          } else {
            addObj(this.addForm)
              .then((response) => {
                this.$message({
                  showClose: true,
                  message: "添加成功",
                  type: "success",
                });
                // done();
                this.addVisible = false;
                this.addForm = {};
                this.getPage(this.page);
              })
              .catch(() => {
                loading();
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    //上传表格
    imtExcel(formData) {
      importExcel(formData)
        .then((res) => {
          if (!!res.data.data) {
            //有返回
            let arr = res.data.data.split(",");
            this.$msgbox({
              title: "提示",
              message: (
                <div style="min-height:100px;max-height:300px;overflow-y:auto;padding:10px 0 10px 10px;">
                  {arr.map((item, index) => (
                    <div style="line-height:30px" key={index}>
                      {item}
                    </div>
                  ))}
                </div>
              ),
              customClass: "excMsg",
              confirmButtonText: "确定",
              beforeClose: (action, instance, done) => {
                done();
              },
            });
          } else {
            this.$message.success("导入成功");
          }
          this.uploadVisible = false;
          this.$refs.uploadImport.init();
          this.getPage(this.page);
        })
        .catch((err) => {
          this.$refs.uploadImport.btnLoading = false;
          this.$message.error(err.data.msg || "导入失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
// /deep/.avue-crud__menu{
//     display: none;
// }
.headerContent {
  margin-left: 85px;
}
/deep/.el-form-item__content {
  display: flex;
}
.pc-dialog {
  /deep/.el-dialog__body {
    height: 337px;
  }
  .dialog-footer {
  display: flex;
  justify-content: center;
}
}

/deep/.el-dialog__footer {
  background: #fff;
}

.check-title {
  font-weight: 500;
  font-size: 16px;
  color: #313133;
}
.desc {
  margin-left: 30px;  
  margin-top: -30px;
  font-weight: 400;
  font-size: 14px;
  color: #626266;
  margin-bottom: 16px;
}
</style>
